var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaneDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 2.1875H2.8125C2.4668 2.1875 2.1875 2.4668 2.1875 2.8125V17.1875C2.1875 17.5332 2.4668 17.8125 2.8125 17.8125H17.1875C17.5332 17.8125 17.8125 17.5332 17.8125 17.1875V2.8125C17.8125 2.4668 17.5332 2.1875 17.1875 2.1875ZM16.4062 16.4062H3.59375V3.59375H16.4062V16.4062Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 16.4062H16.4062V3.59375H3.59375V16.4062ZM6.79492 7.15039C6.77567 7.12775 6.76332 7.10007 6.75934 7.07062C6.75535 7.04117 6.7599 7.0112 6.77245 6.98426C6.78499 6.95732 6.805 6.93454 6.83011 6.91864C6.85521 6.90273 6.88435 6.89437 6.91406 6.89453H8.06445C8.15625 6.89453 8.24414 6.93555 8.30469 7.00586L10 9.02734L11.6953 7.00586C11.7539 6.93555 11.8418 6.89453 11.9355 6.89453H13.0859C13.2188 6.89453 13.291 7.04883 13.2051 7.15039L10.8164 10L13.2051 12.8496C13.291 12.9512 13.2188 13.1055 13.0859 13.1055H11.9355C11.8438 13.1055 11.7559 13.0645 11.6953 12.9941L10 10.9727L8.30469 12.9941C8.24609 13.0645 8.1582 13.1055 8.06445 13.1055H6.91406C6.78125 13.1055 6.70898 12.9512 6.79492 12.8496L9.18359 10L6.79492 7.15039Z",
    fill: "#FCE0C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91422 13.1055H8.06461C8.15836 13.1055 8.24625 13.0645 8.30484 12.9941L10.0002 10.9727L11.6955 12.9941C11.756 13.0645 11.8439 13.1055 11.9357 13.1055H13.0861C13.2189 13.1055 13.2912 12.9512 13.2052 12.8496L10.8166 10L13.2052 7.15039C13.2912 7.04883 13.2189 6.89453 13.0861 6.89453H11.9357C11.842 6.89453 11.7541 6.93555 11.6955 7.00586L10.0002 9.02734L8.30484 7.00586C8.2443 6.93555 8.15641 6.89453 8.06461 6.89453H6.91422C6.78141 6.89453 6.70914 7.04883 6.79508 7.15039L9.18375 10L6.79508 12.8496C6.77583 12.8722 6.76348 12.8999 6.75949 12.9294C6.75551 12.9588 6.76006 12.9888 6.7726 13.0157C6.78515 13.0427 6.80516 13.0655 6.83026 13.0814C6.85536 13.0973 6.8845 13.1056 6.91422 13.1055Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaneDelete);
export default __webpack_public_path__ + "static/media/pane-delete.e82f81da9326dd381ac3b83302e0f859.svg";
export { ForwardRef as ReactComponent };